<template>
   <div class="gens-universev">
       <!-- <div class="img-ss">
            <img class="gens-img" src="../../assets/images/headerimg/Header_1920x380_healthy-life-talent-gene.jpg" />
             <h1 class="gens-title">{{$t('ContractText.Talent_gene_testing')}}</h1>
       </div> -->
       <banner>
            <img src="../../assets/images/headerimg/Header_1920x380_healthy-life-talent-gene.jpg"/>
            <div slot="title">{{$t('ContractText.Talent_gene_testing')}}</div>
        </banner>
       <div class="gens_header_tip">
           <div class="tip_red">{{$t('Talentgenetesting.Talentgenetesting_one')}}</div>
           <div class="tip_white">{{$t('Talentgenetesting.Talentgenetesting_two')}}</div>
       </div>
       <div class="gens_info">
           <div class="gens_content">
                <div class="gens_content_left">
                    <div class="left_tip">{{$t('Talentgenetesting.Talentgenetesting_three')}}</div>
                    <div class="left_line"></div>
                    <div class="left_content">{{$t('Talentgenetesting.Talentgenetesting_four')}}</div>
                    <div class="left_content"> {{$t('Talentgenetesting.Talentgenetesting_five')}}</div>
                    <div class="left_content">{{$t('Talentgenetesting.Talentgenetesting_six')}}</div>
                </div>
                <div class="gens_content_right">
                    <img class="gens_content_right_img" src="../../assets/images/genestesting/healthy-life_icon-21.png"  alt/>
                </div>
           </div>
       </div>
       <div class="gens_info gens_content_special">
           <div class="gens_content">
                <div class="gens_content_left">
                    <img class="gens_content_left_img" src="../../assets/images/genestesting/healthy-life_icon-25.png" alt />   
                </div>
                <div class="gens_content_right text_aligh_left ">
                    <div class="right_tip">{{$t('Talentgenetesting.Talentgenetesting_seven')}}</div>
                    <div class="right_line"></div>
                    <div class="right_content">{{$t('Talentgenetesting.Talentgenetesting_eight')}}</div>
                    <div class="right_content">{{$t('Talentgenetesting.Talentgenetesting_nine')}}</div>
                </div>
           </div>
       </div>
       <div class="gens_transparent">
           <div class="gens_transparent_content">
               <div class="gens_transparent_content_tip">{{$t('Talentgenetesting.Talentgenetesting_ten')}}</div>
               <div class="gens_transparent_content_line"></div>
               <div class="gens_transparent_content_info">
                   <span class="mytick"></span> 
                   <span class="tick_text">{{$t('Talentgenetesting.Talentgenetesting_eleven')}}</span>
                </div>
               <div class="gens_transparent_content_info">
                    <span class="mytick"></span> 
                    <span class="tick_text">{{$t('Talentgenetesting.Talentgenetesting_twelve')}}</span> 
                </div>
               <div class="gens_transparent_content_info">
                    <span class="mytick"></span> 
                     <span class="tick_text">{{$t('Talentgenetesting.Talentgenetesting_threeteen')}}</span> 
                </div>
               <div class="gens_transparent_content_info">
                    <span class="mytick"></span> 
                     <span class="tick_text">{{$t('Talentgenetesting.Talentgenetesting_fourteen')}}</span> 
                </div>
               <div class="gens_transparent_content_info">
                    <span class="mytick"></span> 
                     <span class="tick_text">{{$t('Talentgenetesting.Talentgenetesting_fiveteen')}}</span> 
                </div>
           </div>
       </div>

       <div class="gens_testing_info">
           <div class="gens_testing_info_show">
               <div class="info_show_text">
                   <div v-if="!showInfoDetail" @click="showInfoDetail=true">{{$t('Talentgenetesting.Talentgenetesting_sixteen')}} <br /> 
                        <div class="info_show_text_icon" >
                            <i class="icon iconfont iconxiala xiala"></i>
                        </div>
                   </div>
                   <div v-if="showInfoDetail&&$i18n.locale!='en-US'"  @click="showInfoDetail=false">收起 <br />
                         <div class="info_show_text_icon" >
                            <i class="icon iconfont iconarrowtop xiala"></i>
                        </div>
                   </div>
                   <div v-if="showInfoDetail&&$i18n.locale=='en-US'"  @click="showInfoDetail=false">Retrace <br />
                         <div class="info_show_text_icon" >
                            <i class="icon iconfont iconarrowtop xiala"></i>
                        </div>
                   </div>
                </div>
           </div>
           <div class="gens_testing_detail" v-if="showInfoDetail">
               <div class="detail_content">
                   <div class="detail_tip">{{$t('Talentgenetesting.Talentgenetesting_seventeen')}}</div>
                    <div class="detail_content_item">
                        <div class="item_left">
                            <img class="left_imgs" src="../../assets/images/genestesting/talent-talent.png" alt />   
                        </div>
                        <div class="item_right">
                            <div class="item_right_tip">{{$t('Talentgenetesting.Talentgenetesting_eighteen')}}</div>
                            <div class="item_right_content" v-if="$i18n.locale=='zh-TCC'">
                                <strong>6種天賦潛能：</strong>
                                語言天賦、音樂天賦、數學天賦、閱讀天賦、繪畫天賦、運動天賦
                               
                            </div>
                            <div class="item_right_content" v-if="$i18n.locale=='zh-CN'">
                                <strong>6种天赋潜能：</strong>
                                语言天赋、音乐天赋、数学天赋、阅读天赋、绘画天赋、运动天赋
                               
                            </div>
                            <div class="item_right_content" v-if="$i18n.locale=='en-US'">
                              <strong>{{$t('Talentgenetesting.Talentgenetesting_nineteen')}}</strong>

                              {{$t('Talentgenetesting.Talentgenetesting_nineteens')}}
                            </div>
                        </div>
                    </div>
                    <div class="item_line_d"></div>
                    <div class="detail_content_item">
                        <div class="item_left">
                            <img class="left_imgs" src="../../assets/images/genestesting/talent-eq.png" alt />   
                        </div>
                        <div class="item_right">
                            <div class="item_right_tip color_one"> {{$t('Talentgenetesting.Talentgenetesting_twenty')}}</div>
                            <div class="item_right_content" v-if="$i18n.locale=='zh-TCC'">
                                <strong>5種性格：</strong>
                                多情性格、內向性格、衝動性格、隨和性格、高度敏感性格
                            </div>
                            <div class="item_right_content" v-if="$i18n.locale=='zh-CN'">
                                <strong>5种性格：</strong>
                                多情性格、内向性格、衝动性格、随和性格、高度敏感性格
                            </div>
                            <div class="item_right_content" v-if="$i18n.locale=='en-US'">
                                <strong>{{$t('Talentgenetesting.Talentgenetesting_twenty_one')}}</strong>
                                {{$t('Talentgenetesting.Talentgenetesting_twenty_ones')}}
                            </div>


                            <div class="item_right_content" v-if="$i18n.locale=='zh-TCC'">
                                <strong>4種能力：</strong>
                                堅持力、注意力、領導力、抗壓力
                            </div>
                            <div class="item_right_content" v-if="$i18n.locale=='zh-CN'">
                                <strong>4种能力：</strong>
                                坚持力、注意力、领导力、抗压力
                            </div>
                            <div class="item_right_content" v-if="$i18n.locale=='en-US'">
                                <strong>{{$t('Talentgenetesting.Talentgenetesting_twenty_two')}}</strong>
                               {{$t('Talentgenetesting.Talentgenetesting_twenty_twos')}}
                            </div>

                            <div class="item_right_content" v-if="$i18n.locale=='zh-TCC'">
                                <strong>3種心向：</strong>
                                責任心、好奇心、同理心
                            </div>
                             <div class="item_right_content" v-if="$i18n.locale=='zh-CN'">
                                <strong>3种心向：</strong>
                                责任心、好奇心、同理心
                            </div>
                             <div class="item_right_content" v-if="$i18n.locale=='en-US'">
                                  <strong>{{$t('Talentgenetesting.Talentgenetesting_twenty_three')}}</strong>
                                {{$t('Talentgenetesting.Talentgenetesting_twenty_three')}}
                            </div>

                            <div class="item_right_content" v-if="$i18n.locale=='zh-TCC'">
                                <strong>2種傾向：</strong>
                                焦慮傾向、獎勵依賴
                            </div>
                             <div class="item_right_content" v-if="$i18n.locale=='zh-CN'">
                                <strong>2种倾向：</strong>
                               焦虑倾向、奖励依赖


                            </div>
                             <div class="item_right_content" v-if="$i18n.locale=='en-US'">
                                 <strong>{{$t('Talentgenetesting.Talentgenetesting_twenty_four')}}</strong>
                                {{$t('Talentgenetesting.Talentgenetesting_twenty_fours')}}


                            </div>
                        </div>
                    </div>
                    <div class="item_line_d"></div>

                    <div class="detail_content_item">
                        <div class="item_left">
                            <img class="left_imgs" src="../../assets/images/genestesting/talent-iq.png" alt />   
                        </div>
                        <div class="item_right">
                            <div class="item_right_tip color_two"> {{$t('Talentgenetesting.Talentgenetesting_twenty_five')}}</div>
                            <div class="item_right_content" v-if="$i18n.locale=='zh-TCC'">
                                <strong>8項記憶力：</strong>
                               邏輯記憶力、視覺記憶力、空間記憶力、長期記憶力、短期記憶力、工作記憶力、情景記憶力、語音記憶力
                            </div>
                            <div class="item_right_content" v-if="$i18n.locale=='zh-CN'">
                                <strong>8项记忆力：</strong>
                              逻辑记忆力、视觉记忆力、空间记忆力、长期记忆力、短期记忆力、工作记忆力、情景记忆力、语音记忆力
                            </div>
                            <div class="item_right_content" v-if="$i18n.locale=='en-US'">
                                <strong>{{$t('Talentgenetesting.Talentgenetesting_twenty_six')}}</strong>

                               {{$t('Talentgenetesting.Talentgenetesting_twenty_sixs')}}
                            </div>

                            <div class="item_right_content" v-if="$i18n.locale=='zh-TCC'">
                                <strong>3項智商：</strong>
                               晶體智商、流體智商、操作智商
                            </div>
                             <div class="item_right_content" v-if="$i18n.locale=='zh-CN'">
                                <strong>3项智商：</strong>
                               晶体智商、流体智商、操作智商
                            </div>
                             <div class="item_right_content" v-if="$i18n.locale=='en-US'">
                                <strong> {{$t('Talentgenetesting.Talentgenetesting_twenty_seven')}}</strong>
                              {{$t('Talentgenetesting.Talentgenetesting_twenty_sevens')}}
                            </div>

                            <div class="item_right_content" v-if="$i18n.locale=='zh-TCC'">
                                <strong>3項能力：</strong>
                               避錯能力、認知能力、推理能力
                            </div>
                            <div class="item_right_content" v-if="$i18n.locale=='zh-CN'">
                                <strong>3项能力：</strong>
                               避错能力、认知能力、推理能力
                            </div>
                            <div class="item_right_content" v-if="$i18n.locale=='en-US'">
                                <strong>{{$t('Talentgenetesting.Talentgenetesting_twenty_eight')}}</strong>

                               {{$t('Talentgenetesting.Talentgenetesting_twenty_eights')}}
                            </div>
                        </div>
                    </div>
                    <div class="item_line_d"></div>

                    <div class="detail_content_item">
                        <div class="item_left">
                            <img class="left_imgs" src="../../assets/images/genestesting/talent-nutrition.png" alt />   
                        </div>
                        <div class="item_right">
                            <div class="item_right_tip color_three"> {{$t('Talentgenetesting.Talentgenetesting_twenty_nine')}}</div>
                            <div class="item_right_content" v-if="$i18n.locale=='zh-TCC'">
                                <strong>8種維他命水平：</strong>
                                葉酸水平、維他命A水平、維他命B6水平、維他命B12水平、維他命C水平、維他命D及鈣水平、維他命E水平、維他命K1水平
                            </div>
                            <div class="item_right_content" v-if="$i18n.locale=='zh-CN'">
                                <strong>8种维他命水平：</strong>
                                叶酸水平、维他命A水平、维他命B6水平、维他命B12水平、维他命C水平、维他命D及钙水平、维他命E水平、维他命K1水平
                            </div>
                            <div class="item_right_content" v-if="$i18n.locale=='en-US'">
                                <strong>{{$t('Talentgenetesting.Talentgenetesting_thirty')}}</strong>
                                {{$t('Talentgenetesting.Talentgenetesting_thirtys')}}
                            </div>
                            
                            <div class="item_right_content" v-if="$i18n.locale=='zh-TCC'">
                                <strong>6种微量元素水平：</strong>
                               鋅元素水平、鉛元素水平、硒元素水平、銅元素水平、鐵元素水平、鎂元素水平
                            </div>
                             <div class="item_right_content" v-if="$i18n.locale=='zh-CN'">
                                <strong>6種微量元素水平：</strong>
                               锌元素水平、铅元素水平、硒元素水平、铜元素水平、铁元素水平、镁元素水平
                            </div>
                             <div class="item_right_content" v-if="$i18n.locale=='en-US'">
                                <strong> {{$t('Talentgenetesting.Talentgenetesting_thirty_one')}}</strong>
                                 {{$t('Talentgenetesting.Talentgenetesting_thirty_ones')}}
                            </div>

                            <div class="item_right_content" v-if="$i18n.locale=='zh-TCC'">
                                <strong>2種營養需求：</strong>
                                奧米伽3需求、抗氧化物需求
                            </div>
                             <div class="item_right_content" v-if="$i18n.locale=='zh-CN'">
                                <strong>2种营养需求：</strong>
                                奥米伽3需求、抗氧化物需求
                            </div>
                             <div class="item_right_content" v-if="$i18n.locale=='en-US'">
                                 <strong>
                                  {{$t('Talentgenetesting.Talentgenetesting_thirty_two')}}

                                 </strong>
                                  {{$t('Talentgenetesting.Talentgenetesting_thirty_twos')}}
                            </div>

                            <div class="item_right_content" v-if="$i18n.locale=='zh-TCC'">
                                <strong>10種健康風險：</strong>
                                酒精依賴程度、咖啡耐受性、雀斑風險、青春痘風險、高度近視、牙周炎、過敏性鼻炎、易曬黑傾向、乳糖代謝能力、遺傳過敏性濕疹
                            </div>
                            <div class="item_right_content" v-if="$i18n.locale=='zh-CN'">
                                <strong>10种健康风险：</strong>
                                酒精依赖程度、咖啡耐受性、雀斑风险、青春痘风险、高度近视、牙周炎、过敏性鼻炎、易晒黑倾向、乳糖代谢能力、遗传过敏性湿疹
                            </div>
                            <div class="item_right_content" v-if="$i18n.locale=='en-US'">
                                <strong> {{$t('Talentgenetesting.Talentgenetesting_thirty_three')}}</strong>
                                  {{$t('Talentgenetesting.Talentgenetesting_thirty_threes')}}
                            </div>
                        </div>
                    </div>
                    <div class="item_line_d"></div>
                    <div class="detail_content_item">
                        <div class="item_left">
                            <img class="left_imgs" src="../../assets/images/genestesting/talent-fitness.png" alt />   
                        </div>
                        <div class="item_right">
                            <div class="item_right_tip color_four"> {{$t('Talentgenetesting.Talentgenetesting_thirty_four')}}</div>
                            <div class="item_right_content" v-if="$i18n.locale=='zh-TCC'">
                                <strong>10種身體特質：</strong>
                                爆發力、耐力、骨骼強壯程度、運動損傷風險、肺功能、運動減肥效果、身高、力量訓練的塑形效果、甜味偏好度、飽和脂肪酸對肥胖的影響
                            </div>
                            <div class="item_right_content" v-if="$i18n.locale=='zh-CN'">
                                <strong>10种身体特质：</strong>
                                爆发力、耐力、骨骼强壮程度、运动损伤风险、肺功能、运动减肥效果、身高、力量训练的塑形效果、甜味偏好度、饱和脂肪酸对肥胖的影响
                            </div>
                            <div class="item_right_content" v-if="$i18n.locale=='en-US'">
                                <strong> {{$t('Talentgenetesting.Talentgenetesting_thirty_five')}}</strong>
                                {{$t('Talentgenetesting.Talentgenetesting_thirty_fives')}}
                            </div>
                        </div>
                    </div>
                    
               </div>
           </div>

           <div class="gens_result">
               <div class="gens_result_info">
                   <div class="gens_result_info_tip">
                       <div class="result_text"> {{$t('Talentgenetesting.Talentgenetesting_thirty_six')}}</div>
                       <div class="result_line"></div>
                   </div>
                   <div class="gens_result_science">
                       <div class="science_item">
                           <div class="science_item_img">
                               <img class="img_science" src="../../assets/images/genestesting/university-logo_V0.1-01.png" alt />   
                           </div>
                           <div class="science_tip"> {{$t('Talentgenetesting.Talentgenetesting_thirty_seven')}}</div>
                           <div class="science_abstract">
                               <span class="abstract_tip"> {{$t('Talentgenetesting.Talentgenetesting_thirty_eight')}}</span>
                               <span class="number">1</span>
                           </div>
                       </div>
                        <div class="science_item">
                           <div class="science_item_img">
                               <img class="img_science" src="../../assets/images/genestesting/university-logo_V0.1-02.png" alt />   
                           </div>
                           <div class="science_tip"> {{$t('Talentgenetesting.Talentgenetesting_thirty_nine')}}</div>
                           <div class="science_abstract">
                               <span class="abstract_tip"> {{$t('Talentgenetesting.Talentgenetesting_fourty')}}</span>
                               <span class="number">2</span>
                           </div>
                       </div>
                        <div class="science_item">
                           <div class="science_item_img">
                               <img class="img_science" src="../../assets/images/genestesting/university-logo_V0.1-06.png" alt />   
                           </div>
                           <div class="science_tip">{{$t('Talentgenetesting.Talentgenetesting_fourty_one')}}</div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Talentgenetesting.Talentgenetesting_fourty_two')}}</span>
                               <span class="number">3</span>
                           </div>
                       </div>
                        <div class="science_item">
                           <div class="science_item_img">
                               <img class="img_science" src="../../assets/images/genestesting/university-logo_V0.1-05.png" alt />   
                           </div>
                           <div class="science_tip">{{$t('Talentgenetesting.Talentgenetesting_fourty_three')}}</div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Talentgenetesting.Talentgenetesting_fourty_four')}}</span>
                               <span class="number">4</span>
                           </div>
                       </div>
                        <div class="science_item">
                           <div class="science_item_img">
                               <img class="img_science" src="../../assets/images/genestesting/university-logo_V0.1-03.png" alt />   
                           </div>
                           <div class="science_tip">{{$t('Talentgenetesting.Talentgenetesting_fourty_five')}}</div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Talentgenetesting.Talentgenetesting_fourty_six')}}</span>
                               <span class="number">5</span>
                           </div>
                       </div>
                        <div class="science_item">
                           <div class="science_item_img">
                               <img class="img_science" src="../../assets/images/genestesting/university-logo_V0.1-04.png" alt />   
                           </div>
                           <div class="science_tip">{{$t('Talentgenetesting.Talentgenetesting_fourty_seven')}}</div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Talentgenetesting.Talentgenetesting_fourty_eight')}}</span>
                               <span class="number">6</span>
                           </div>
                       </div>
                   </div>
               </div>
           </div>


           <div class="gens_result gens_result_special">
               <div class="gens_result_info">
                   <div class="gens_result_info_tip">
                       <div class="result_text">{{$t('Talentgenetesting.Talentgenetesting_fourty_nine')}}</div>
                       <div class="result_line"></div>
                       <div class="tip_img">
                           <img class="tip_img_s" src="../../assets/images/genestesting/xss.png" alt />   
                       </div>
                       <div class="tip_text_sk">{{$t('Talentgenetesting.Talentgenetesting_fifty')}}</div>
                   </div>
                   <div class="gens_result_science">
                       <div class="science_item science_item_special">
                           <div class="science_item_img">
                               <img class="img_science img_science_special" src="../../assets/images/genestesting/healthy-life_icon-01.png" alt />   
                           </div>
                           <div class="science_tip">{{$t('Talentgenetesting.Talentgenetesting_fifty_one')}}</div>
                           <hr>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Talentgenetesting.Talentgenetesting_fifty_two')}}</span>
                           </div>
                       </div>
                        <div class="science_item science_item_special">
                           <div class="science_item_img">
                               <img class="img_science img_science_special" src="../../assets/images/genestesting/healthy-life_icon-02.png" alt />   
                           </div>
                           <div class="science_tip">{{$t('Talentgenetesting.Talentgenetesting_fifty_three')}}</div>
                           <hr>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Talentgenetesting.Talentgenetesting_fifty_four')}}</span>
                              
                           </div>
                       </div>
                        <div class="science_item science_item_special">
                           <div class="science_item_img">
                               <img class="img_science img_science_special" src="../../assets/images/genestesting/healthy-life_icon-03.png" alt />   
                           </div>
                           <div class="science_tip">{{$t('Talentgenetesting.Talentgenetesting_fifty_five')}}</div>
                           <hr>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Talentgenetesting.Talentgenetesting_fifty_six')}}</span>
                           </div>
                       </div>
                        <div class="science_item science_item_special">
                           <div class="science_item_img">
                               <img class="img_science img_science_special" src="../../assets/images/genestesting/healthy-life_icon-04.png" alt />   
                           </div>
                           <div class="science_tip">{{$t('Talentgenetesting.Talentgenetesting_fifty_seven')}}</div>
                           <hr>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Talentgenetesting.Talentgenetesting_fifty_eight')}}</span>
                           </div>
                       </div>
                        <div class="science_item science_item_special">
                           <div class="science_item_img">
                               <img class="img_science img_science_special" src="../../assets/images/genestesting/healthy-life_icon-05.png" alt />   
                           </div>
                           <div class="science_tip">{{$t('Talentgenetesting.Talentgenetesting_fifty_nine')}}</div>
                           <hr>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Talentgenetesting.Talentgenetesting_sixty')}}</span>
                           </div>
                       </div>
                   </div>
                   <div class="gens_example">
                       <div class="example_item">
                           <div class="example_item_img">
                               <div class="zhezhaoceng"></div>
                               <img class="example_item_imgs" src="../../assets/images/genestesting/talent-sample-collection.png" alt /> 
                               <div class="gens_ex_text">{{$t('Talentgenetesting.Talentgenetesting_sixty_one')}}</div> 
                               <div class="gens_ex_text_back">
                                   <div class="back_content">
                                       <div class="back_text">{{$t('Talentgenetesting.Talentgenetesting_sixty_two')}}</div>
                                       <div>
                                           <div @click="showVideo('../../../static/videos/天賦基因套餐_採樣視頻.mp4')" class="movie">{{$t('Talentgenetesting.Talentgenetesting_sixty_three')}}</div>
                                        </div>
                                    </div>

                               </div> 
                           </div>

                         <el-dialog
                           title="提示"
                           :visible.sync="dialogVideoVisible"
                           :close-on-click-modal="false"
                           :before-close="handleDialogVideoClose"
                           @open="handleDialogVideoOpen"
                           width="70%">
                           <div slot="title">{{$t('indexText.more')}}</div>
                           <video class="video" src="../../../static/videos/天賦基因套餐_採樣視頻.mp4" controls autoplay style="width: 100%;"></video>
                         </el-dialog>
                       </div>
                       <div class="example_item">
                           <div class="example_item_img">
                               <div class="zhezhaoceng"></div>
                               <img class="example_item_imgs" src="../../assets/images/genestesting/talent-report-consultation.png" alt /> 
                               <div class="gens_ex_text">{{$t('Talentgenetesting.Talentgenetesting_sixty_four')}}</div> 
                               <div class="gens_ex_text_back">
                                   <div class="back_content">
                                       <div class="back_text">{{$t('Talentgenetesting.Talentgenetesting_sixty_five')}}</div>
                                       
                                    </div>

                               </div> 
                           </div>

                       </div>
                       <div class="example_item">
                           <div class="example_item_img">
                               <div class="zhezhaoceng"></div>
                               <img class="example_item_imgs" src="../../assets/images/genestesting/talent-picture.jpg" alt /> 
                               <div class="gens_ex_text">{{$t('Talentgenetesting.Talentgenetesting_sixty_six')}}</div> 
                               <div class="gens_ex_text_back">
                                   <div class="back_content">
                                       <div class="back_text">{{$t('Talentgenetesting.Talentgenetesting_sixty_seven')}}</div>
                                       <div>
                                           <div @click="showVideo('../../../static/videos/天賦基因套餐_媽媽專訪.mp4')" class="movie">{{$t('Talentgenetesting.Talentgenetesting_sixty_eight')}}</div>
                                        </div>
                                    </div>

                               </div> 
                           </div>

                       </div>
                   </div>
               </div>
           </div>

            <div class="gens_result">
               <div class="gens_result_info">
                   <div class="gens_result_info_tip">
                       <div class="result_text">{{$t('Talentgenetesting.Talentgenetesting_sixty_nine')}}</div>
                       <div class="result_line"></div>
                   </div>
                   <div class="gens_result_science">
                       <div class="science_item science_item_special">
                           <div class="science_item_img">
                               <img class="img_science img_science_special" src="../../assets/images/genestesting/healthy-life_icon-06.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <div class="abstract_tip">{{$t('Talentgenetesting.Talentgenetesting_seventy')}}</div>
                               <div class="abstract_tip" v-if="$i18n.locale=='en-US'">{{$t('Talentgenetesting.Talentgenetesting_seventys')}}</div>

                           </div>
                       </div>
                        <div class="science_item science_item_special">
                           <div class="science_item_img">
                               <img class="img_science img_science_special" src="../../assets/images/genestesting/healthy-life_icon-07.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Talentgenetesting.Talentgenetesting_seventy_one')}}</span>
                              
                           </div>
                       </div>
                        <div class="science_item science_item_special">
                           <div class="science_item_img">
                               <img class="img_science img_science_special" src="../../assets/images/genestesting/healthy-life_icon-08.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Talentgenetesting.Talentgenetesting_seventy_two')}}</span>
                           </div>
                       </div>
                        <div class="science_item science_item_special">
                           <div class="science_item_img">
                               <img class="img_science img_science_special" src="../../assets/images/genestesting/healthy-life_icon-09.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Talentgenetesting.Talentgenetesting_seventy_three')}}</span>
                           </div>
                       </div>
                   </div>
                 
               </div>
           </div>


           <div class="gens_result gens_result_special">
               <div class="gens_result_info">
                   <div class="gens_result_info_tip">
                       <div class="result_text">{{$t('Talentgenetesting.Talentgenetesting_seventy_four')}}</div>
                       <div class="result_line"></div>
                   </div>
                    <div class="gens_result_example">
                        <div class="gens_result_example_item">
                            <div class="gens_result_example_item_img">
                                 <img class="gens_result_example_item_imgs" src="../../assets/images/genestesting/talent-jacob.png" alt />  
                            </div>
                            <div class="gens_result_example_tip">
                                {{$t('Talentgenetesting.Talentgenetesting_eighty_one')}}
                            </div>
                            <div class="gens_result_example_content">
                                {{$t('Talentgenetesting.Talentgenetesting_eighty_two')}}
                            </div>
                            <div class="gens_result_example_bottom">{{$t('Talentgenetesting.Talentgenetesting_eighty_three')}}</div>
                        </div>
                        <div class="gens_result_example_item">
                            <div class="gens_result_example_item_img">
                                 <img class="gens_result_example_item_imgs" src="../../assets/images/genestesting/talent-june.png" alt />  
                            </div>
                            <div class="gens_result_example_tip">
                                {{$t('Talentgenetesting.Talentgenetesting_seventy_five')}}
                            </div>
                            <div class="gens_result_example_content">
                                {{$t('Talentgenetesting.Talentgenetesting_seventy_six')}}
                            </div>
                            <div class="gens_result_example_bottom">{{$t('Talentgenetesting.Talentgenetesting_seventy_seven')}}</div>
                        </div>
                        <div class="gens_result_example_item">
                            <div class="gens_result_example_item_img">
                                 <img class="gens_result_example_item_imgs" src="../../assets/images/genestesting/talent-charlotte.png" alt />  
                            </div>
                            <div class="gens_result_example_tip">
                                {{$t('Talentgenetesting.Talentgenetesting_seventy_eight')}}
                            </div>
                            <div class="gens_result_example_content">
                                {{$t('Talentgenetesting.Talentgenetesting_seventy_nine')}}
                            </div>
                            <div class="gens_result_example_bottom">{{$t('Talentgenetesting.Talentgenetesting_eighty')}}</div>
                        </div>
                    </div>
               </div>
           </div>


           <div class="gens_last">
               <div class="gens_last_info">
                    <div class="gens_last_tip">
                       <div class="gens_last_text">{{$t('Talentgenetesting.Talentgenetesting_eighty_four')}}</div>
                       <div class="gens_lastline"></div>
                    </div>
                   <div class="gens_last_top">
                       <div class="gens_last_item">
                           <div class="gens_last_item_left">
                               <div class="last_item_left_conten">
                                   <i class="iconfont icon iconyinhao yinhao"></i>
                                   <span class="conten_text">{{$t('Talentgenetesting.Talentgenetesting_eighty_five')}}</span>
                               </div>
                               <div class="last_item_left_conten">
                                   <i class="iconfont icon iconyinhao yinhao"></i>
                                   <span class="conten_text">{{$t('Talentgenetesting.Talentgenetesting_eighty_six')}}</span>
                               </div>
                               <div class="last_item_left_conten">
                                   <i class="iconfont icon iconyinhao yinhao"></i>
                                   <span class="conten_text">{{$t('Talentgenetesting.Talentgenetesting_eighty_seven')}}</span>
                               </div>
                               <div class="last_item_left_conten">
                                   <i class="iconfont icon iconyinhao yinhao"></i>
                                   <span class="conten_text">{{$t('Talentgenetesting.Talentgenetesting_eighty_eight')}}</span>
                               </div>
                               <div class="last_item_left_conten">
                                   <i class="iconfont icon iconyinhao yinhao"></i>
                                   <span class="conten_text">{{$t('Talentgenetesting.Talentgenetesting_eighty_nine')}}</span>
                               </div>
                           </div>
                       </div>
                       <div class="gens_last_item">
                           <div class="gens_last_item_right">
                             <video src="../../../static/videos/天賦基因套餐_QandA.mp4" controls style="width: 100%;height: 310px;object-fit: fill;"></video>
                           </div>
                       </div>
                   </div>
                   <div class="gens_last_bottom">
                       <div class="gens_last_bottom_tip">{{$t('Talentgenetesting.Talentgenetesting_ninety')}}</div>
                       <div class="gens_last_bottom_content">1. Lettre G, Jackson AU, Gieger C, et al. Nat Genet. 2008 40(5):584-91.</div>
                       <div class="gens_last_bottom_content">2. Zilberman-Schapira G, Chen J, Gerstein M, et al. Recent Pat DNA Gene Seq. 2012 6(3):180-8.</div>
                       <div class="gens_last_bottom_content">3. Newbury DF, Winchester L, Addis L, et al. Am J Hum Genet. 2009 85(2):264-72.</div>
                       <div class="gens_last_bottom_content">4. Docherty SJ, Davis OS, Kovas Y, et al. Genes Brain Behav. 2010 9(2):234-47.</div>
                       <div class="gens_last_bottom_content">5. Service SK, Verweij KJ, Lahti J, et al. Transl Psychiatry. 2012 2:e116.</div>
                       <div class="gens_last_bottom_content">6. De Neve JE, Mikhaylov S, Dawes CT, et al. Leadersh Q. 2013 24(1):45-60.</div>
                   </div>
               </div>
           </div>
           

           

       </div>

   </div>
</template>
<script>
import banner from '@/components/banner'

  function videoPlay() {
    let video = $('.video')[0];
    try {
      video.play();
    } catch (e) {
    }
  }
  function videoPause() {
    let video = $('.video')[0];
    try {
      video.pause();
    } catch (e) {
    }
  }
export default {
    data(){
        return{
            showInfoDetail:false,
            dialogVideoVisible: false,
            videoSrc: '',
        }
    },
    components: {
      banner,
     
    },
    mounted(){

    },
    methods:{
      showVideo(src){
        console.log(src);
        this.dialogVideoVisible = true;
        this.videoSrc = src;
      },
      handleDialogVideoOpen(){
        $('.video').attr('src', this.videoSrc);
        videoPlay();
      },
      handleDialogVideoClose(){
        this.dialogVideoVisible = false;
        videoPause();
      },
    }
}
</script>

<style lang="scss" scoped>
.video{
   box-shadow: 0 0 5px #999;
}
  @import '../../assets/font/iconfont.css';
.gens-universev{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    .img-ss{
        position: relative;
        // display: flex;
        .gens-img{
            max-width: 100%;
            height: auto;
            position: relative;
        }
         .gens-title{
                   top:0;
                    width: 100%;
                    height: 100%;
                    font-size: 47px;
                    line-height: 60px;
                    color: #fff;
                    position: absolute;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                    padding-left:10%;
                    padding-right:10%;
                    font-weight: 600;
            }
    }
    .gens_header_tip{
        background-color:#f1c480;
        padding-top:30px;
        padding-bottom:30px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .tip_red{
            text-align: center;
            color: #ef682f;
            text-shadow: 1px 1px 2px #ffffff;
            font-size: 28px;
            font-style: normal;
            font-weight: 700;
            text-transform: none;
            line-height: 1.384615384615385em;
        }
        .tip_white{
            text-align: center;
            color: #ffffff;
            text-shadow: 1px 1px 2px #ef682f;
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            text-transform: none;
            margin-top:24px;
            line-height: 1.571428571428571em;
        }
    }

    .gens_info{
       
       background-color:#ffffff;
       padding-top:60px;
       padding-bottom:30px;
       .gens_content{
           width:1200px;
            margin:auto;
           display: flex;
           justify-content: space-between;
          
           flex-direction: row;
           flex-wrap: wrap;
           .gens_content_left{
               width:50%;
               text-align: left;
                display: inline-block;
                vertical-align: baseline;
                position: relative;
                max-width: 100%;
               .left_tip{
                    color: #f1c480;
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
               }
               .left_line{
                    margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #f1c480;
                    width: 250px;
                    margin-left: 0;
                    margin-right: 0;    
                    height: 2px;
                    position: relative;
                    display: block;
               }
               .left_content{
                   color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    margin-bottom:24px;
               }
               .gens_content_left_img{
                   height: auto;
                   
                   max-width: 100%;
                   vertical-align: middle;
               }
           }
           .gens_content_right{
               width:50%;
               text-align: center;
               display: inline-block;
                vertical-align: baseline;
                position: relative;
                max-width: 100%;
                padding-left:25px;
                padding-right:25px;
               
                .gens_content_right_img{
                        height: auto;
                        width:259px;
                        max-width: 100%;
                        vertical-align: middle;
                        img {
                            height: auto;
                            max-width: 100%;
                        }
                }
                .right_tip{
                    color: #f1c480;
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                }
                .right_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #f1c480;
                    width: 250px;
                    margin-left: 0;
                    margin-right: 0;    
                    height: 2px;
                    position: relative;
                    display: block;
                }
                .right_content{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    margin-bottom:24px;
                }
                  
           }
          

           .text_aligh_left{
               text-align: left !important;
           }
       }
       
    }
    .gens_content_special{
        background-color: rgba(249,218,179,0.2) !important;
    }

    .gens_transparent{
        background-image: url('../../assets/images/genestesting/genecode_2.jpg');
        background-position: 50% 73px;
        background-size: 100%;
        position: static;
        padding: 0;
        background-repeat: no-repeat;
        background-color: transparent;
        background-position: center 0;
        background-attachment: fixed;
        overflow: hidden;
        display: block;
        .gens_transparent_content{
            width:1200px;
            margin:auto;
            padding-top: 60px;
            padding-bottom: 60px;
            text-align: left;
            .gens_transparent_content_tip{
                margin-bottom: 0;
                color: #f1c480;
                font-size: 28px;
                font-style: normal;
                font-weight: 700;
                text-transform: none;  
                line-height: 1.384615384615385em;    
                letter-spacing: 1px;
                margin-block-start: 0.83em;
                margin-block-end: 0.83em;
                margin-inline-start: 0px;
                margin-inline-end: 0px;
                display: block;
            }
            .gens_transparent_content_line{
                margin-top: 10px;
                margin-bottom: 30px;
                background-color: #f1c480;
                width: 250px;
                margin-left: 0;
                margin-right: 0;
                height: 2px;
                position: relative;
                display: block;
            }
            .gens_transparent_content_info{
                margin-bottom: 21px;
               
                .mytick{
                    color: #ef682f;
                    background: 0 0;
                    border: 0;
                    font-size: 18px;
                    height: 16px;
                    width: 16px;
                    display: inline-block;
                    position: relative;
                    border:2px solid #ef682f;
                }
                .mytick:before,.mytick:after {
                    content: '';
                    pointer-events: none;
                    position: absolute;
                    color: #ef682f;
                    border: 2px solid #ef682f;
                    background-color: white;
                }
                .mytick:before {
                    width: 1px;
                    height: 0px;
                    left: 18%;
                    top: 46%;
                    transform: skew(0deg, 50deg);
                }
                .mytick:after {
                    width: 11px;
                    height: 0px;
                    left: 38%;
                    top: 15%;
                    transform: skew(0deg, -50deg);
                }

                .tick_text{
                    line-height: 27px;
                    font-weight: 400;
                    margin: 0 0 10px;
                    padding: 0 0 0 38px;
                    position: relative;
                    color: #3a3a3a;
                    font-size: 16px;
                    margin-bottom: -12px;
                }
            }
        }
    }
    .gens_testing_info{
        background-color:#fff;
        .gens_testing_info_show{
            .info_show_text{
                display: block;
                position: relative;
                margin: 0;
                padding: 39px 0 15px;
                color: rgb(239, 104, 47);
                font-size: 19px;
                font-weight: 600;
                line-height: 22px;
                cursor: pointer;
                z-index: 90;
                text-align: center;
            }
            .info_show_text_icon{
                display: inline-block;
                font: 14px/1 FontAwesome;
                font-size: inherit;
                text-rendering: auto;
                -webkit-font-smoothing: antialiased;
                text-align: center;
                cursor: pointer;
                .xiala{
                    color:rgb(239, 104, 47);
                    font-size:16px;
                }
                .xiala:hover{
                     color:rgb(241, 196, 128) !important;
                }
                


            }

            .info_show_text:hover{
                color:rgb(241, 196, 128) !important;
            }
            .info_show_text:hover .xiala{
                color:rgb(241, 196, 128) !important;
            }
            .gens_testing_info_show:hover{
                color:rgb(241, 196, 128) !important;
            }


        }
    }


    .gens_testing_detail{
        background-color:#fff;
        .detail_content{
            width:1200px;
            margin:auto;
            margin-bottom:24px;
            .detail_tip{
                text-align: center;
                color: #ef682f;
                font-size: 24px;
                font-style: normal;
                font-weight: 600;
                text-transform: none;
                margin-bottom: 30px;
                line-height: 1.304347826086957em;
                letter-spacing: 1px;
            }
             .detail_content_item{
                 width:85%;
                 margin: auto;
                display:flex;
                justify-content: flex-start;
                flex-direction: row;
                align-items: center;
                 padding-bottom:0;
                .item_left{
                    display: inline-block;
                    vertical-align: top;
                    width:25%;
                    text-align: left;
                    .left_imgs{
                        width:150px;
                        vertical-align: middle;    
                        height: auto;
                        max-width: 100%;
                    }
                }
                .item_right{
                    width:75%;
                    text-align: left;
                    .item_right_tip{
                        color: #e29490;
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 600;
                        text-transform: none;
                        line-height: 1.375em;
                        margin-bottom:24px;
                    }
                    .item_right_content{
                        color: #3a3a3a;
                        font-size: 16px;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                        margin-bottom:24px;
                    }
                    .color_one{
                        color: #ebac80 !important;
                    }
                    .color_two{
                        color: #9cb843 !important;
                    }
                    .color_three{
                        color: #5892c7 !important;
                    }
                    .color_four{
                        color: #af8eb3 !important;
                    }
                }
            }
            .item_line_d{
                    position: relative;
                    display: block;
                    height: 1px;
                    background-color: #eaeaea;
                    margin: 10px 0;
                    margin-bottom: 30px;
            }
          
        }
       
    }


     .gens_result{
         background-color: rgba(249,218,179,0.2);
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
        
         .gens_result_info{
             width:1200px;
             margin:auto;
             .gens_result_info_tip{
                 .result_text{
                     color: #f1c480;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .result_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #f1c480;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }
                 .tip_img{
                         display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                        margin-bottom:30px;
                        .tip_img_s{
                            height: auto;
                            max-width: 100%;
                            width: 300px;
                        }
                 }
                 .tip_text_sk{
                     color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    margin-bottom:30px;
                 }
             }
             .gens_result_science{
                  display:flex;
                  justify-content: left;
                  flex-direction: row;
                 .science_item{
                    width:16.66%;
                    text-align: center;
                    .science_item_img{
                        display: grid;
                        justify-content: center;
                        width: 100%;
                        position: relative;
                        .img_science{
                            display: block;
                            margin: 0 0 15px ;
                            max-width: 100%;
                            height: auto;
                        }
                        .img_science_special{
                            width:150px !important;
                        }
                        
                    }

                    hr{
                            color: #9a9a9a;
                            display: block;
                            unicode-bidi: isolate;
                            margin-block-start: 0.5em;
                            margin-block-end: 0.5em;
                            margin-inline-start: auto;
                            margin-inline-end: auto;
                            overflow: hidden;
                            border-style: inset;
                            border-width: 1px;
                            border-top: 1px solid #9a9a9a !important;
                        }
                    .science_tip{
                        color: #ef682f;
                        font-size: 24px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 1.304347826086957em;
                        text-transform: none;
                        letter-spacing: 1px;
                        margin-inline-start: 0px;
                        margin-inline-end: 0px;
                    }
                    .science_abstract{
                         margin: 16px 0px 6px 0px;
                        .abstract_tip{
                           
                            font-size:16px;
                        }
                        .number{
                            font-size: .5em;
                            vertical-align: super;
                        }
                    }

                 }
                 .science_item_special{
                    padding-left: 15px;
                    padding-right: 15px;
                }
             }

             .gens_example{
                 display: flex;
                 justify-content: flex-start;
                 align-items: center;
                 margin-top:35px;
                 .example_item{
                     width:33.33%;
                     margin-right:30px;
                     .example_item_img{
                         display: inline-block;
                        position: relative;
                        margin: 0;
                        width: 100%;
                       
                        .example_item_imgs{

                            max-width: 100%;
                            height: auto;
                            display: block;
                            position: relative;
                            width: 100%;
                            z-index: 10;
                        }
                        
                        .zhezhaoceng{
                            background-color: rgba(241,196,128,0.9);
                            opacity: 0;
                            transition: opacity .4s ease-in-out;
                            z-index: 20;
                            -webkit-transition: opacity .4s ease-in-out;
                            -moz-transition: opacity .4s ease-in-out;
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            left: 0;
                            top: 0;
                            background-color: transparent;
                        }
                        
                        .gens_ex_text{
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            top: 0;
                            left: 0;
                            z-index: 30;
                            text-align: center;
                            color:#fff;
                            line-height: 1em;
                            opacity: 1;
                            -webkit-transition: opacity .4s ease-in-out;
                            font-size: 24px;
                            font-style: normal;
                            font-weight: 600;
                            text-transform: none;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                      
                        .gens_ex_text_back{
                            opacity: 0;
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            top: 0;
                            left: 0;
                            z-index: 40;
                            text-align: center;
                            color:#fff;
                            line-height: 1em;
                            font-size: 24px;
                            font-style: normal;
                            font-weight: 600;
                            text-transform: none;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            .back_content{
                                .back_text{
                                    margin-bottom: 20px;
                                    color: #ffffff;
                                    font-size: 24px;
                                    font-style: normal;
                                    font-weight: 600;
                                    text-transform: none;
                                    letter-spacing: 1px;
                                }
                                .movie{
                                    color: rgb(255, 255, 255);
                                    border-color: rgb(239, 104, 47);
                                    letter-spacing: 3px;
                                    background-color: rgb(239, 104, 47);
                                    font-size: 14px;
                                    line-height: 36px;
                                    height: 36px;
                                    font-style: normal;
                                    font-weight: 400;
                                    border-width: 2px;
                                    border-radius: 5px;
                                    text-decoration:none;
                                    position: relative;
                                    width: auto;
                                    padding: 0 23px;
                                    transition: color .1s linear , background-color .1s linear , border-color .1s linear;
                                    box-sizing: initial!important;
                                    display:inline-block;
                                    margin: 0;
                                }
                                .movie:hover{
                                    color: rgb(239, 104, 47);
                                    border-color: rgb(255, 255, 255);
                                    letter-spacing: 3px;
                                    background-color: rgb(255, 255, 255);
                                }
                            }
                        }
                     }
                     .example_item_img:hover{
                         .zhezhaoceng{
                             opacity: 1;
                             background-color: rgba(241,196,128,0.9);
                         }
                         .gens_ex_text{
                             opacity: 0;
                         }
                         .gens_ex_text_back{
                             opacity: 1;
                         }
                     }
                 }
             }

             .gens_result_example{
                   display:flex;
                  justify-content: left;
                  flex-direction: row;
                  .gens_result_example_item{
                      margin-right:30px;
                      width:380px;
                      background: rgba(249,218,179,.2);
                      padding: 40px 30px;
                      box-sizing: border-box;
                      text-align: center;
                      display:flex;
                      flex-direction: column;
                      justify-content: flex-start;
                      .gens_result_example_item_img{
                              border-radius: 50%;
                              margin-bottom: 33px;
                              text-align: center;
                              vertical-align: middle;
                              margin: 0 0 50px;
                              display: inline-block;
                              position: relative;
                              overflow: hidden;
                          .gens_result_example_item_imgs{
                              width: 150px;
                              max-width: 100%;
                              height: auto;
                          }
                      }
                      .gens_result_example_tip{
                            color: #ef682f;
                            padding-bottom: 20px;
                            font-size: 24px;
                            font-style: normal;
                            font-weight: 600;
                            text-transform: none;
                            line-height: 1.304347826086957em;
 
                      }
                      .gens_result_example_content{
                              text-align: left;
                              color: #3a3a3a;
                              font-size:16px;
                              font-weight: 400;
                              line-height: 24px;
                              font-style: normal;
                              height: 360px;
                      }
                      .gens_result_example_bottom{
                          text-align: center;
                          color: #ef682f;
                          margin-top: 21px;
                          font-size: 13px;
                          font-weight: 500;
                          line-height: 24px;
                          font-style: normal;
                      }
                  }
             }
             

         }
         
       
     }
     .gens_result_special{
         background-color:#fff !important;
     }

     .gens_last{
            background-image: url(../../assets/images/genestesting/genecode-faq.png);
            padding-top: 60px;
            padding-bottom: 60px;
            text-align: left;
            position: relative;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: cover;
            margin-bottom: 0!important;
            .gens_last_info{
                width:1200px;
                margin:auto;
                .gens_last_tip{
                    .gens_last_text{
                        color: #fff;
                        font-size: 28px;
                        font-style: normal;
                        font-weight: 700;
                        text-transform: none;
                        line-height: 1.384615384615385em;
                        letter-spacing: 1px;
                    }
                    .gens_lastline{
                        margin-top: 10px;
                        margin-bottom: 30px;
                        background-color: #fff;;
                        width: 250px;
                        height: 2px;
                        position: relative;
                        display: block;
                    }

                   
               
                }
                .gens_last_top{
                    overflow: hidden;
                    display: flex;
                    justify-content: flex-start;
                    flex-direction: row;
                    align-items: center;
                    .gens_last_item{
                         width: 50%;
                         display:flex;
                         justify-content: flex-start;
                         flex-direction: row;
                         align-items: center;
                        .gens_last_item_left{
                            box-sizing: border-box;
                            // padding-left: 15px;
                            padding-right: 15px;
                            width: 100%;
                            border-left:#ef682f 6px solid;
                            border-left-color: #ef682f;
                            background-color: rgba(249,218,179,0.7);
                            .last_item_left_conten{
                                padding: 14px 14px 14px 10px;
                                flex-direction: inherit;
                                display: flex;;
                                .yinhao{
                                    color:#ef682f;
                                    font-size:28px;
                                    margin: 6px 0 0!important;
                                    padding-left:5px;
                                }
                                .conten_text{
                                    padding: 0 0 0 20px;
                                    color: #242729;
                                    font-size: 21px;
                                    line-height: 32px;
                                    letter-spacing: 0px;
                                    text-transform: none;
                                    font-style: normal;
                                    font-weight: 300;
                                    margin: 0!important;
                                }
                            }
                        }
                        .gens_last_item_right{
                            margin-left:30px;
                            left: 0;
                            position: absolute;
                            text-align: center;
                            top: 0px;
                            transition: background-color .2s ease-in-out;
                            position: relative;
                            width: 100%;
                            height: auto;
                            z-index:20;
                           iframe{
                                
                                width: 100%;
                                height: 340px;
                                display: block;
                                margin: 0;
                                top: 0;
                                left: 0;
                           }
                        }
                    }
                }

                .gens_last_bottom{
                    margin-top:30px;
                    .gens_last_bottom_tip{
                        font-size: 12px;
                        color: #ffffff;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                        display: block;
                        margin-block-start: 1em;
                        margin-block-end: 1em;
                        margin-inline-start: 0px;
                        margin-inline-end: 0px;
                    }
                    .gens_last_bottom_content{
                        font-size: 12px;
                        color: #ffffff;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                        display: block;
                        letter-spacing: 0.07em !important;
                        vertical-align: baseline;
                    }
                }
            }
     }
           
}
</style>



// WEBPACK FOOTER //
// src/view/genedetection/innategene.vue